import { render } from "./Index.vue?vue&type=template&id=863874a2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=863874a2&lang=scss&scoped=true"
import "./Index.vue?vue&type=style&index=1&id=863874a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-863874a2"

export default script